"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Agenda2Cell;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _utils = require("../utils");
var _agenda2Themes = require("./agenda2Themes");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
// Agenda 2.0. Same data as AgendaCell (agendas_days / agendas_categories / agendas_events keyed by
// cell_id, so the /csv_agenda/ import works for both) but:
//  - times are shown exactly as imported (the CSV stores wall-clock times as UTC, so we read UTC
//    fields instead of subtracting an hour from the viewer's local time);
//  - days are compared on the full date (year, month, day), not on the day of the month;
//  - past events / past days are only hidden when `hide_past_events` is on;
//  - categories are optional: events without category are listed, and an "All" tab is available;
//  - no absolute positioning, the list scrolls inside `list_max_height_vh`;
//  - two layouts (`cell.layout`): 'timeline' (times on the left, a vertical line, cards on the right, day tabs as a
//    pill bar) and 'cards'.

var LABELS = {
  fr: {
    all: 'Tous',
    empty: 'Aucun événement'
  },
  nl: {
    all: 'Alle',
    empty: 'Geen evenementen'
  },
  en: {
    all: 'All',
    empty: 'No events'
  }
};
var label = function label(intl, key) {
  var lang = intl && intl.locale ? intl.locale.slice(0, 2) : 'en';
  return (LABELS[lang] || LABELS.en)[key];
};
var ALL = '__all__';
var pad = function pad(n) {
  return n.toString().padStart(2, '0');
};
var formatTime = function formatTime(date) {
  return pad(date.getUTCHours()) + ':' + pad(date.getUTCMinutes());
};

// Timeline layout writes times as 10.30
var formatTimeDots = function formatTimeDots(date) {
  return pad(date.getUTCHours()) + '.' + pad(date.getUTCMinutes());
};
var formatDateDots = function formatDateDots(date) {
  return pad(date.getUTCDate()) + '.' + pad(date.getUTCMonth() + 1) + '.' + date.getUTCFullYear();
};

// Popups and the subtitle ("function") use Open Sans by default; a font picked in the description editor still wins.
var POPUP_FONT = "OpenSans-Regular, 'Open Sans', sans-serif";

// A short plain text description (a status such as "Closed meeting") is shown next to the title in the timeline
// layout; anything longer or with html keeps the "+" button that opens the popup.
var isShortText = function isShortText(text) {
  return !!text && text.length <= 80 && !/<[^>]+>/.test(text) && !text.includes('\n');
};

// What a card shows and what its popup opens:
//  - status: the small text next to the title. The `subtitle` of the event when it has one (even empty = none);
//    otherwise, as for imported events, a short plain description.
//  - content: the description shown in the popup (not the short description already used as status).
//  - hasPopup: `popup` true = always a popup, false = never, unset = a popup when there is a description or an image.
var eventView = function eventView(event, description) {
  var hasSubtitle = event.subtitle !== null && event.subtitle !== undefined;
  var legacyStatus = !hasSubtitle && isShortText(description) ? description : null;
  var status = hasSubtitle ? event.subtitle : legacyStatus;
  var content = legacyStatus ? '' : description;
  var hasPopup = event.popup === true || event.popup === false ? event.popup : !!(content || event.image_uri);
  return {
    status: status,
    content: content,
    hasPopup: hasPopup
  };
};

// Per-event title typography, set by hand in the event editor. Only overrides what's actually set, so the
// cell's own title style (color/size/weight from the theme) still applies otherwise.
var titleStyleOverride = function titleStyleOverride(event) {
  var style = {};
  if (event.title_bold) style.fontWeight = 'bold';
  if (event.title_italic) style.fontStyle = 'italic';
  if (event.title_font_family) style.fontFamily = event.title_font_family;
  if (event.title_color) style.color = event.title_color;
  if (event.title_font_size) style.fontSize = event.title_font_size + 'em';
  return style;
};

// Comparable number for the calendar day of a Date read in UTC (YYYYMMDD).
var dayNumber = function dayNumber(date) {
  return date.getUTCFullYear() * 10000 + (date.getUTCMonth() + 1) * 100 + date.getUTCDate();
};

// The viewer's current wall-clock time expressed the same way the CSV stores times (as if UTC).
var nowAsWallClock = function nowAsWallClock() {
  var n = new Date();
  return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes()));
};
var byDate = function byDate(field) {
  return function (a, b) {
    return new Date(a[field]) - new Date(b[field]);
  };
};
function Agenda2Cell(_ref) {
  var cell = _ref.cell,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer,
    intl = _ref.intl,
    defaultLanguage = _ref.defaultLanguage,
    project = _ref.project,
    logEvent = _ref.logEvent;
  var days = (0, _react.useMemo)(function () {
    return _toConsumableArray(cell.days || []).sort(byDate('date'));
  }, [cell.days]);
  var categories = (0, _react.useMemo)(function () {
    return cell.categories || [];
  }, [cell.categories]);
  var events = (0, _react.useMemo)(function () {
    return _toConsumableArray(cell.events || []).sort(function (a, b) {
      return new Date(a.start) - new Date(b.start) || new Date(a.end) - new Date(b.end);
    });
  }, [cell.events]);
  var timeline = cell.layout !== 'cards';
  var hasCategories = categories.length > 0;
  var showCategoryBar = hasCategories && (!timeline || categories.length > 1);
  var showAllTab = showCategoryBar && cell.show_all_tab !== false;
  var visibleDays = (0, _react.useMemo)(function () {
    if (!cell.hide_past_events) return days;
    var today = dayNumber(nowAsWallClock());
    return days.filter(function (day) {
      return dayNumber(new Date(day.date)) >= today;
    });
  }, [days, cell.hide_past_events]);
  var defaultDayId = (0, _react.useMemo)(function () {
    if (visibleDays.length === 0) return null;
    var today = dayNumber(nowAsWallClock());
    var current = visibleDays.find(function (day) {
      return dayNumber(new Date(day.date)) === today;
    });
    if (current) return current.id;
    var upcoming = visibleDays.find(function (day) {
      return dayNumber(new Date(day.date)) > today;
    });
    return (upcoming || visibleDays[0]).id;
  }, [visibleDays]);
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    pickedDay = _ref3[0],
    setPickedDay = _ref3[1];
  var _ref4 = (0, _react.useState)(null),
    _ref5 = _slicedToArray(_ref4, 2),
    pickedCategory = _ref5[0],
    setPickedCategory = _ref5[1];
  var _ref6 = (0, _react.useState)(null),
    _ref7 = _slicedToArray(_ref6, 2),
    currentEvent = _ref7[0],
    setCurrentEvent = _ref7[1];
  var selectedDay = visibleDays.some(function (d) {
    return d.id === pickedDay;
  }) ? pickedDay : defaultDayId;
  var selectedCategory = function () {
    if (!showCategoryBar) return ALL;
    if (pickedCategory === ALL && showAllTab) return ALL;
    if (categories.some(function (c) {
      return c.id === pickedCategory;
    })) return pickedCategory;
    return showAllTab ? ALL : categories[0].id;
  }();
  var log = function log(type, data) {
    if (logEvent) {
      logEvent(type, _objectSpread({
        cellId: cell.id,
        pageId: cell.page_id,
        languageCode: intl ? intl.locale : null
      }, data));
    }
  };
  var now = nowAsWallClock();
  var shownEvents = events.filter(function (event) {
    if (event.agenda_day_id !== selectedDay) return false;
    if (selectedCategory !== ALL && event.category_id !== selectedCategory) return false;
    if (cell.hide_past_events && new Date(event.end) < now) return false;
    return true;
  });
  var locale = intl ? intl.locale : 'en';
  // The background image chosen in the editor wins; without one, the Euroseeds theme brings its own.
  var customBackground = cell.background_image_uri ? uriTransformer(cell.background_image_uri) : null;
  var backgroundImageUri = customBackground || (cell.color_theme === 'euroseeds' ? _agenda2Themes.EUROSEEDS_BACKGROUND : null);
  var backgroundSize = customBackground ? {
    contain: 'contain',
    stretch: '100% 100%'
  }[cell.background_fit] || 'cover' : 'cover';
  var backgroundImageStyle = backgroundImageUri ? {
    backgroundImage: 'url("' + backgroundImageUri + '")',
    backgroundSize: backgroundSize,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  } : {};
  var radius = function radius(enabled, size) {
    return enabled ? size / 2 + 0.5 + 'em' : '0em';
  };
  var pill = function pill(selected, colors, size, rounded) {
    return {
      flex: '1 0 auto',
      cursor: 'pointer',
      padding: '0.4em 0.9em',
      fontSize: size + 'em',
      fontWeight: 'bold',
      textAlign: 'center',
      transitionDuration: '200ms',
      background: selected ? colors.checkedBackground : 'rgba(0,0,0,0)',
      color: selected ? colors.selectedText : colors.text,
      border: 'solid 0.1em ' + (selected ? colors.border : 'rgba(0,0,0,0)'),
      borderRadius: radius(rounded, size)
    };
  };
  if (timeline) {
    var timeColor = cell.text_color_time;
    var details = {
      color: cell.text_color_card_details,
      fontSize: cell.font_size_details + 'em',
      margin: '0.5em 0 0'
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      style: _objectSpread(_objectSpread({
        padding: '4%',
        boxSizing: 'border-box',
        width: '100%',
        minHeight: '100%',
        backgroundColor: cell.background_color
      }, backgroundImageStyle), {}, {
        color: cell.text_color,
        fontFamily: project ? project.default_button_font : 'initial'
      })
    }, showCategoryBar && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        overflowX: 'auto',
        marginBottom: '0.6em'
      }
    }, showAllTab && /*#__PURE__*/_react.default.createElement("div", {
      style: pill(selectedCategory === ALL, {
        checkedBackground: cell.background_color_filter_category_checked,
        selectedText: cell.text_color_category_filter_selected,
        text: cell.text_color_category_filter,
        border: cell.border_color_selected_category
      }, cell.font_size_filter_category, true),
      onClick: function onClick() {
        setPickedCategory(ALL);
        log('click', {
          category_selected: ALL
        });
      }
    }, label(intl, 'all')), categories.map(function (category) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: category.id,
        style: pill(selectedCategory === category.id, {
          checkedBackground: cell.background_color_filter_category_checked,
          selectedText: cell.text_color_category_filter_selected,
          text: cell.text_color_category_filter,
          border: cell.border_color_selected_category
        }, cell.font_size_filter_category, true),
        onClick: function onClick() {
          setPickedCategory(category.id);
          log('click', {
            category_selected: category.name
          });
        }
      }, (0, _utils.i18nData)(category, 'name', intl, defaultLanguage));
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        overflowX: 'auto',
        boxSizing: 'border-box',
        gap: '0.3em',
        padding: '0.35em',
        borderRadius: '999px',
        border: 'solid 1px ' + cell.border_color_selected_day,
        backgroundColor: cell.background_color_filter_day
      }
    }, visibleDays.map(function (day) {
      var date = new Date(day.date);
      var selected = selectedDay === day.id;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: day.id,
        onClick: function onClick() {
          setPickedDay(day.id);
          log('click', {
            day_selected: date.toISOString()
          });
        },
        style: {
          flex: '1 1 0',
          minWidth: 'fit-content',
          cursor: 'pointer',
          boxSizing: 'border-box',
          padding: '0.65em 0.8em',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          lineHeight: 1.3,
          fontSize: cell.font_size_filter_day * 0.8 + 'em',
          transitionDuration: '200ms',
          borderRadius: '999px',
          fontWeight: selected ? 'bold' : 'normal',
          background: selected ? cell.background_color_filter_day_checked : 'rgba(0,0,0,0)',
          color: selected ? cell.text_color_day_filter_selected : cell.text_color_day_filter
        }
      }, /*#__PURE__*/_react.default.createElement("div", null, date.toLocaleDateString(locale, {
        weekday: 'long',
        timeZone: 'UTC'
      })), /*#__PURE__*/_react.default.createElement("div", null, formatDateDots(date)));
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginTop: '1.6em',
        maxHeight: (cell.list_max_height_vh || 70) + 'vh',
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    }, shownEvents.length === 0 && /*#__PURE__*/_react.default.createElement("p", {
      style: {
        textAlign: 'center',
        opacity: 0.6,
        fontSize: cell.font_size_details + 'em'
      }
    }, label(intl, 'empty')), shownEvents.map(function (event) {
      var start = new Date(event.start);
      var end = new Date(event.end);
      var showEnd = cell.show_end_time !== false && end > start;
      var _eventView = eventView(event, (0, _utils.i18nData)(event, 'description', intl, defaultLanguage)),
        status = _eventView.status,
        hasMore = _eventView.hasPopup;
      var titleImage = (0, _utils.i18nData)(event, 'image_uri', intl, defaultLanguage);
      return /*#__PURE__*/_react.default.createElement("div", {
        key: event.id,
        style: {
          display: 'flex',
          alignItems: 'stretch'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: '0 0 5em',
          paddingTop: '1.05em',
          paddingRight: '0.3em',
          boxSizing: 'border-box',
          textAlign: 'center',
          color: timeColor,
          lineHeight: 1.45
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontWeight: 'bold',
          fontSize: cell.font_size_time * 1.35 + 'em'
        }
      }, formatTimeDots(start)), showEnd && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontSize: cell.font_size_time * 1.2 + 'em'
        }
      }, formatTimeDots(end))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          minWidth: 0,
          boxSizing: 'border-box',
          padding: '0.7em 0 0.7em 1.2em',
          borderLeft: 'solid 0.2em ' + cell.color_timeline
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box',
          padding: '1.1em 1.2em',
          borderRadius: '0.5em',
          border: 'solid 1px rgba(0,0,0,0.1)',
          boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
          backgroundColor: cell.background_color_event
        }
      }, titleImage && /*#__PURE__*/_react.default.createElement("img", {
        src: uriTransformer(titleImage),
        alt: "",
        style: {
          flex: '0 0 auto',
          width: '2.6em',
          height: '2.6em',
          objectFit: 'contain',
          marginRight: '0.9em'
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          minWidth: 0
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: _objectSpread({
          color: cell.text_color_card,
          fontSize: cell.font_size_name + 'em',
          fontWeight: 500,
          lineHeight: 1.35
        }, titleStyleOverride(event))
      }, (0, _utils.i18nData)(event, 'name', intl, defaultLanguage), status && (cell.subtitle_new_line ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: '0.25em',
          fontWeight: 'normal',
          fontFamily: POPUP_FONT,
          fontSize: '0.75em',
          lineHeight: 1.35,
          color: cell.text_color_card_details
        }
      }, status) : /*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginLeft: '0.6em',
          whiteSpace: status.length > 30 ? 'normal' : 'nowrap',
          fontWeight: 'normal',
          fontFamily: POPUP_FONT,
          fontSize: '0.65em',
          color: cell.text_color_card_details
        }
      }, "(", status, ")"))), event.speaker && /*#__PURE__*/_react.default.createElement("p", {
        style: details
      }, /*#__PURE__*/_react.default.createElement(SpeakerSVG, null), " ", (0, _utils.i18nData)(event, 'speaker', intl, defaultLanguage)), event.location && /*#__PURE__*/_react.default.createElement("p", {
        style: details
      }, /*#__PURE__*/_react.default.createElement(LocationSVG, null), " ", (0, _utils.i18nData)(event, 'location', intl, defaultLanguage)), event.language && /*#__PURE__*/_react.default.createElement("p", {
        style: details
      }, /*#__PURE__*/_react.default.createElement(LangSVG, null), " ", (0, _utils.i18nData)(event, 'language', intl, defaultLanguage))), hasMore && /*#__PURE__*/_react.default.createElement("span", {
        role: "button",
        onClick: function onClick() {
          setCurrentEvent(event);
          log('click', {
            event_opened: event.name
          });
        },
        style: {
          flex: '0 0 auto',
          marginLeft: '0.8em',
          cursor: 'pointer',
          width: '1.6em',
          height: '1.6em',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          borderRadius: '50%',
          background: cell.background_color_button_open,
          color: cell.text_color_card,
          border: 'solid 0.08em ' + cell.text_color_card
        }
      }, "+"))));
    })), /*#__PURE__*/_react.default.createElement(PopUpEvent, {
      event: currentEvent,
      close: function close() {
        return setCurrentEvent(null);
      },
      cell: cell,
      intl: intl,
      defaultLanguage: defaultLanguage,
      uriTransformer: uriTransformer
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({
      padding: '2%',
      boxSizing: 'border-box',
      width: '100%',
      minHeight: '100%',
      backgroundColor: cell.background_color
    }, backgroundImageStyle), {}, {
      color: cell.text_color,
      fontFamily: project ? project.default_button_font : 'initial'
    })
  }, showCategoryBar && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      overflowX: 'auto',
      backgroundColor: cell.background_color_filter_category,
      borderRadius: radius(cell.bolder_radius_filter_category, cell.font_size_filter_category),
      padding: '0.15em'
    }
  }, showAllTab && /*#__PURE__*/_react.default.createElement("div", {
    style: pill(selectedCategory === ALL, {
      checkedBackground: cell.background_color_filter_category_checked,
      selectedText: cell.text_color_category_filter_selected,
      text: cell.text_color_category_filter,
      border: cell.border_color_selected_category
    }, cell.font_size_filter_category, cell.bolder_radius_filter_category),
    onClick: function onClick() {
      setPickedCategory(ALL);
      log('click', {
        category_selected: ALL
      });
    }
  }, label(intl, 'all')), categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: category.id,
      style: pill(selectedCategory === category.id, {
        checkedBackground: cell.background_color_filter_category_checked,
        selectedText: cell.text_color_category_filter_selected,
        text: cell.text_color_category_filter,
        border: cell.border_color_selected_category
      }, cell.font_size_filter_category, cell.bolder_radius_filter_category),
      onClick: function onClick() {
        setPickedCategory(category.id);
        log('click', {
          category_selected: category.name
        });
      }
    }, (0, _utils.i18nData)(category, 'name', intl, defaultLanguage));
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      overflowX: 'auto',
      marginTop: '0.6em',
      backgroundColor: cell.background_color_filter_day,
      borderRadius: radius(cell.bolder_radius_filter_day, cell.font_size_filter_day),
      padding: '0.15em'
    }
  }, visibleDays.map(function (day) {
    var date = new Date(day.date);
    var weekday = date.toLocaleDateString(locale, {
      weekday: 'short',
      timeZone: 'UTC'
    });
    var dayMonth = date.toLocaleDateString(locale, {
      day: '2-digit',
      month: 'short',
      timeZone: 'UTC'
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      key: day.id,
      style: pill(selectedDay === day.id, {
        checkedBackground: cell.background_color_filter_day_checked,
        selectedText: cell.text_color_day_filter_selected,
        text: cell.text_color_day_filter,
        border: cell.border_color_selected_day
      }, cell.font_size_filter_day, cell.bolder_radius_filter_day),
      onClick: function onClick() {
        setPickedDay(day.id);
        log('click', {
          day_selected: date.toISOString()
        });
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, weekday.toUpperCase()), /*#__PURE__*/_react.default.createElement("div", null, dayMonth.toUpperCase()));
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '0.6em',
      maxHeight: (cell.list_max_height_vh || 70) + 'vh',
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }, shownEvents.length === 0 && /*#__PURE__*/_react.default.createElement("p", {
    style: {
      textAlign: 'center',
      opacity: 0.6,
      fontSize: cell.font_size_details + 'em'
    }
  }, label(intl, 'empty')), shownEvents.map(function (event) {
    var start = new Date(event.start);
    var end = new Date(event.end);
    var time = cell.show_end_time !== false && end > start ? formatTime(start) + ' - ' + formatTime(end) : formatTime(start);
    var details = {
      color: cell.text_color_event_details,
      fontSize: cell.font_size_details + 'em',
      margin: '0.2em 0 0'
    };
    var _eventView2 = eventView(event, (0, _utils.i18nData)(event, 'description', intl, defaultLanguage)),
      status = _eventView2.status,
      hasPopup = _eventView2.hasPopup;
    var titleImage = (0, _utils.i18nData)(event, 'image_uri', intl, defaultLanguage);
    return /*#__PURE__*/_react.default.createElement("div", {
      key: event.id,
      style: {
        padding: '0.4em 0.25em'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        boxShadow: '0.3em 0.3em 0.6em rgba(0,0,0,0.2)',
        border: 'solid 1px rgba(128,128,128,0.45)',
        padding: '0.8em 1em',
        borderRadius: '0.5em'
      }
    }, titleImage && /*#__PURE__*/_react.default.createElement("img", {
      src: uriTransformer(titleImage),
      alt: "",
      style: {
        flex: '0 0 auto',
        width: '2.6em',
        height: '2.6em',
        objectFit: 'contain',
        marginRight: '0.9em'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        minWidth: 0
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        margin: 0,
        fontWeight: 'bold',
        color: cell.text_color_time,
        fontSize: cell.font_size_time + 'em'
      }
    }, time), /*#__PURE__*/_react.default.createElement("p", {
      style: _objectSpread({
        margin: '0.2em 0 0',
        fontWeight: 'bold',
        color: cell.text_color_event_name,
        fontSize: cell.font_size_name + 'em'
      }, titleStyleOverride(event))
    }, (0, _utils.i18nData)(event, 'name', intl, defaultLanguage)), status && /*#__PURE__*/_react.default.createElement("p", {
      style: _objectSpread(_objectSpread({}, details), {}, {
        fontFamily: POPUP_FONT
      })
    }, status), event.speaker && /*#__PURE__*/_react.default.createElement("p", {
      style: details
    }, /*#__PURE__*/_react.default.createElement(SpeakerSVG, null), " ", (0, _utils.i18nData)(event, 'speaker', intl, defaultLanguage)), event.location && /*#__PURE__*/_react.default.createElement("p", {
      style: details
    }, /*#__PURE__*/_react.default.createElement(LocationSVG, null), " ", (0, _utils.i18nData)(event, 'location', intl, defaultLanguage)), event.language && /*#__PURE__*/_react.default.createElement("p", {
      style: details
    }, /*#__PURE__*/_react.default.createElement(LangSVG, null), " ", (0, _utils.i18nData)(event, 'language', intl, defaultLanguage))), hasPopup && /*#__PURE__*/_react.default.createElement("span", {
      role: "button",
      onClick: function onClick() {
        setCurrentEvent(event);
        log('click', {
          event_opened: event.name
        });
      },
      style: {
        flex: '0 0 auto',
        marginLeft: '0.8em',
        cursor: 'pointer',
        width: '1.6em',
        height: '1.6em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        borderRadius: '50%',
        background: cell.background_color_button_open,
        color: cell.text_color_button_open,
        border: 'solid 0.08em ' + cell.text_color_button_open
      }
    }, "+")));
  })), /*#__PURE__*/_react.default.createElement(PopUpEvent, {
    event: currentEvent,
    close: function close() {
      return setCurrentEvent(null);
    },
    cell: cell,
    intl: intl,
    defaultLanguage: defaultLanguage,
    uriTransformer: uriTransformer
  }));
}
function PopUpEvent(_ref8) {
  var event = _ref8.event,
    close = _ref8.close,
    cell = _ref8.cell,
    intl = _ref8.intl,
    defaultLanguage = _ref8.defaultLanguage,
    uriTransformer = _ref8.uriTransformer;
  if (!event) {
    return null;
  }
  var details = {
    color: cell.text_color_event_details,
    fontSize: cell.font_size_popup + 'em',
    margin: '0.5em 0'
  };
  var description = eventView(event, (0, _utils.i18nData)(event, 'description', intl, defaultLanguage)).content;
  var image = (0, _utils.i18nData)(event, 'image_uri', intl, defaultLanguage);
  var start = new Date(event.start);
  var end = new Date(event.end);

  // Portal to <body>: the page grid (react-grid-layout) positions every cell with a CSS transform, which turns
  // `position: fixed` into "fixed to the cell": the popup then opened below the cell's top and could not scroll.
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement("div", {
    onClick: close,
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.6)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    style: {
      position: 'relative',
      boxSizing: 'border-box',
      width: '88%',
      maxWidth: '40em',
      maxHeight: '85vh',
      overflowY: 'auto',
      padding: '1.2em',
      borderRadius: '0.6em',
      boxShadow: '0 1em 2em rgba(0,0,0,0.4)',
      backgroundColor: cell.background_color_pop_up,
      color: cell.text_color_description,
      fontFamily: POPUP_FONT
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    onClick: close,
    role: "button",
    style: {
      position: 'absolute',
      top: '0.4em',
      right: '0.7em',
      cursor: 'pointer',
      fontSize: '1.4em',
      color: cell.color_button_close
    }
  }, "\u2715"), /*#__PURE__*/_react.default.createElement("p", {
    style: {
      margin: '0 1.5em 0.2em 0',
      fontSize: cell.font_size_time + 'em',
      color: cell.text_color_event_details
    }
  }, formatTime(start), end > start ? ' - ' + formatTime(end) : ''), /*#__PURE__*/_react.default.createElement("p", {
    style: _objectSpread({
      margin: '0 1.5em 0.4em 0',
      fontWeight: 'bold',
      fontSize: cell.font_size_name + 'em',
      color: cell.text_color_event_name
    }, titleStyleOverride(event))
  }, (0, _utils.i18nData)(event, 'name', intl, defaultLanguage)), event.speaker && /*#__PURE__*/_react.default.createElement("p", {
    style: details
  }, /*#__PURE__*/_react.default.createElement(SpeakerSVG, null), " ", (0, _utils.i18nData)(event, 'speaker', intl, defaultLanguage)), event.location && /*#__PURE__*/_react.default.createElement("p", {
    style: details
  }, /*#__PURE__*/_react.default.createElement(LocationSVG, null), " ", (0, _utils.i18nData)(event, 'location', intl, defaultLanguage)), event.language && /*#__PURE__*/_react.default.createElement("p", {
    style: details
  }, /*#__PURE__*/_react.default.createElement(LangSVG, null), " ", (0, _utils.i18nData)(event, 'language', intl, defaultLanguage)), description && /*#__PURE__*/_react.default.createElement("div", {
    className: "tsk-html-description",
    style: {
      marginTop: '0.8em',
      fontSize: cell.font_size_popup + 'em'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, ".tsk-html-description ul{display:block !important;list-style:disc !important;padding-left:1.4em !important;margin:0.4em 0 !important}.tsk-html-description ol{display:block !important;list-style:decimal !important;padding-left:1.4em !important;margin:0.4em 0 !important}.tsk-html-description li{display:list-item !important;list-style:inherit !important}"), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), image && !/<img\b/i.test(description || '') && /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer(image),
    alt: "",
    style: {
      marginTop: '1em',
      maxWidth: '12em',
      maxHeight: '12em',
      display: 'block',
      margin: '1em auto 0',
      objectFit: 'contain'
    }
  }))), document.body);
}
var iconProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 24 24',
  fill: 'currentColor',
  style: {
    verticalAlign: '-0.125em'
  },
  'aria-hidden': true
};
function LocationSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", iconProps, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"
  }));
}
function SpeakerSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", iconProps, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0 2c-3.3 0-8 1.7-8 5v1h16v-1c0-3.3-4.7-5-8-5z"
  }));
}
function LangSVG() {
  return /*#__PURE__*/_react.default.createElement("svg", iconProps, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.9 6h-2.95a15.7 15.7 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.9 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14a8.2 8.2 0 0 1 0-4h3.38a16.5 16.5 0 0 0 0 4H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.99 7.99 0 0 1 5.08 16zM8.03 8H5.08a7.99 7.99 0 0 1 4.33-3.56A15.7 15.7 0 0 0 8.03 8zM12 19.96A14.1 14.1 0 0 1 10.09 16h3.82A14.1 14.1 0 0 1 12 19.96zM14.34 14H9.66a14.7 14.7 0 0 1 0-4h4.68a14.7 14.7 0 0 1 0 4zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14a16.5 16.5 0 0 0 0-4h3.38a8.2 8.2 0 0 1 0 4h-3.38z"
  }));
}